import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class InterviewSchedule extends DomainObject {
  @observable templateName;
}

export default InterviewSchedule;
